import { map as mapUtils } from '@gisatcz/ptr-utils';
/**
 * Prepare places
 * @param geonames {Array}
 * @param searchString {string}
 * @returns {Array}
 */

var preparePlaces = function preparePlaces(geonames, searchString) {
  if (geonames !== null && geonames !== void 0 && geonames.length) {
    return geonames.map(function (item) {
      var toponymName = item.toponymName,
          countryName = item.countryName,
          adminName1 = item.adminName1,
          geonameId = item.geonameId,
          name = item.name,
          bbox = item.bbox,
          lat = item.lat,
          lng = item.lng;
      var description = "".concat(toponymName);
      var details = [];

      if (countryName) {
        details.push(countryName);
      }

      if (adminName1) {
        details.push(adminName1);
      }

      if (details.length) {
        description = "".concat(description, " (").concat(details.join(', '), ")");
      }

      var pantherMapView = mapUtils.view.getViewFromBoundingBox({
        minLat: (bbox === null || bbox === void 0 ? void 0 : bbox.south) || Number(lat) - 0.001,
        minLon: (bbox === null || bbox === void 0 ? void 0 : bbox.east) || Number(lng) - 0.001,
        maxLat: (bbox === null || bbox === void 0 ? void 0 : bbox.north) || Number(lat) + 0.001,
        maxLon: (bbox === null || bbox === void 0 ? void 0 : bbox.west) || Number(lng) + 0.001
      }, true);
      return {
        id: geonameId,
        name: name,
        description: description,
        bbox: bbox,
        lat: lat,
        lon: lng,
        pantherMapView: pantherMapView,
        originalData: item
      };
    });
  } else {
    return [{
      name: searchString,
      description: 'No location found for given string',
      info: true
    }];
  }
};
/**
 * Fetch places from gazetteer
 * @param apiUrl {string} service url
 * @param apiKey {string} api authorization key
 * @param searchString {string} string to search
 * @param maxItems {number} max number of items to be returned
 * @param handleItems {function} callback taking founded places as first argument
 */


export var fetchGeonames = function fetchGeonames(apiUrl, apiKey, searchString, maxItems, handleItems) {
  fetch("".concat(apiUrl, "?q=").concat(searchString, "&fuzzy=0.7&maxRows=").concat(maxItems, "&inclBbox=true&username=").concat(apiKey)).then(function (res) {
    return res.json();
  }).then(function (result) {
    if (result !== null && result !== void 0 && result.geonames) {
      handleItems(preparePlaces(result.geonames, searchString));
    } else {
      console.warn('No geonames found');
    }
  }, function (error) {
    throw new Error(error);
  });
};